var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HttpClient } from "@angular/common/http";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { ModalService } from "app/views/modal/base_modal.component";
import { HelperService } from "app/lib/helper.service";
import { ChartParams } from "../../views/chart/chart.component";
import { SiteTopDetailsModalComponent } from "./site_top_details.component";
import merge from 'lodash-es/merge';
import { FilterParams } from "../../models/filter_form.model";
import * as qs from 'qs';
import { parseDate } from "../../lib/lib";
import { SitesService } from "../sites.service";
var SiteTopComponent = /** @class */ (function (_super) {
    __extends(SiteTopComponent, _super);
    function SiteTopComponent(eventsService, activatedRoute, translate, router, modalService, filter, http, route, helper, siteService) {
        var _this = _super.call(this, eventsService, siteService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.http = http;
        _this.route = route;
        _this.helper = helper;
        _this.siteService = siteService;
        _this.chart = new ChartParams();
        _this.statsLoader = false;
        _this.paginationLoader = false;
        _this.totalPages = 1;
        _this.currentPage = 1;
        _this.names = {
            'hitCount': _this.translate.__A('site.site_top.hitCount'),
            'hostCount': _this.translate.__A('site.site_top.hostCount'),
            'siteCount': _this.translate.__A('common.sites'),
            'uniqCount': _this.translate.__A('site.site_top.uniqueCount'),
        };
        _this.addFilterParams = {
            dateFilters: ['dateLoadStat'],
            dateFilterParams: {
                dateLoadStat: {
                    start: parseDate().subtract(30, 'day').format('DD-MM-YYYY'),
                    end: parseDate().format('DD-MM-YYYY'),
                    type: 'other'
                }
            }
        };
        _this.dontLoad = {};
        return _this;
    }
    SiteTopComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getStats()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getPagination()];
                    case 3:
                        _a.sent();
                        this.dontLoad = {};
                        return [2 /*return*/];
                }
            });
        });
    };
    SiteTopComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stats = [];
                        this.statsLoader = true;
                        return [4 /*yield*/, this.siteService.siteTop.stats(this.filter.filterParams).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.stats = stats;
                        this.statsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SiteTopComponent.prototype.getChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dontLoad.chart) {
                            return [2 /*return*/, true];
                        }
                        this.chart.showLoader();
                        return [4 /*yield*/, this.siteService.siteTop.chart(this.filter.filterParams).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.chart.data = charts;
                        this.chart.setOptions({
                            names: this.names
                        });
                        this.chart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    SiteTopComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.dontLoad.pagination) {
                            return [2 /*return*/, true];
                        }
                        this.paginationLoader = true;
                        return [4 /*yield*/, this.siteService.siteTop.pagination(this.filter.filterParams).toPromise()];
                    case 1:
                        pagination = _a.sent();
                        this.pagination.fill(pagination);
                        this.paginationLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SiteTopComponent.prototype.applyFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.route });
                return [2 /*return*/];
            });
        });
    };
    SiteTopComponent.prototype.resetFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.currentPage = 1;
                this.filter.filterParams = new FilterParams();
                this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = merge({}, this.filter.getDiffParams(this.filter.filterParams)), url = this.router.url.split('?')[0];
                delete params.dateFilters;
                delete params.dateFilterParams;
                this.router.navigate([url], { relativeTo: this.route, queryParams: params });
                return [2 /*return*/];
            });
        });
    };
    SiteTopComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                this.dontLoad = {
                    chart: true,
                    pagination: true
                };
                return [2 /*return*/];
            });
        });
    };
    SiteTopComponent.prototype.showDetails = function (host) {
        return __awaiter(this, void 0, void 0, function () {
            var modalRef, charts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        modalRef = this.modalService.open(SiteTopDetailsModalComponent, {
                            title: host,
                        }, { size: 'hg' });
                        modalRef.componentInstance.chart = new ChartParams();
                        modalRef.componentInstance.chart.showLoader();
                        return [4 /*yield*/, this.siteService.siteTop.chart(this.filter.getCopyFilterParams({ siteUrl: host })).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        modalRef.componentInstance.chart.data = charts;
                        modalRef.componentInstance.chart.setOptions({
                            names: this.names
                        });
                        modalRef.componentInstance.chart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    return SiteTopComponent;
}(BaseComponent));
export { SiteTopComponent };
